import { JSONContent } from "@tiptap/react";
import cloneDeep from "lodash.clonedeep";

import {
  generateDateTitle,
  removeExerciseCompletionNodes,
  updateDateTitleToToday,
} from "./workouts/document-utils";

export const getEmptyWorkoutDoc = (): JSONContent => {
  const title = generateDateTitle();
  return {
    content: [
      {
        content: [
          {
            type: "text",
            text: title,
          },
        ],
        type: "heading",
        attrs: {
          level: 1,
        },
      },
      {
        type: "paragraph",
      },
    ],
    type: "doc",
  };
};

export const cloneWorkoutDoc = (document: JSONContent): JSONContent => {
  const transformers = [
    cloneDeep,
    updateDateTitleToToday,
    removeExerciseCompletionNodes,
  ];
  return transformers.reduce(
    (transformedDocument, transformer) => transformer(transformedDocument),
    document
  );
};
